/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GoogleCalendarEventsControllerDeleteEvent$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Organizer email address
 */
  organizerEmail: string;

/**
 * Event ID
 */
  eventId: string;
  createdAt: string;
  entity: string;
}

export function googleCalendarEventsControllerDeleteEvent(http: HttpClient, rootUrl: string, params: GoogleCalendarEventsControllerDeleteEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, googleCalendarEventsControllerDeleteEvent.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('organizerEmail', params.organizerEmail, {});
    rb.path('eventId', params.eventId, {});
    rb.path('createdAt', params.createdAt, {});
    rb.path('entity', params.entity, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

googleCalendarEventsControllerDeleteEvent.PATH = '/thalea-google-events/google-calendar-events/{tenant}/{organizerEmail}/{eventId}/{createdAt}/{entity}';
